var _path, _path2, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCampaigns = function SvgCampaigns(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Campaigns_svg__a)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "Campaigns_svg__b",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 1,
    width: 30,
    height: 29
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.4 10.32V7.679a5.28 5.28 0 0 0-5.28-5.28H9.28A5.28 5.28 0 0 0 4 7.678v10.56a5.28 5.28 0 0 0 5.28 5.28h13.2",
    stroke: "#000",
    strokeWidth: 2.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m17.2 18.238 5.28 5.28-5.28 5.28M24.08 18.238l5.28 5.28-5.28 5.28",
    stroke: "#000",
    strokeWidth: 2.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#Campaigns_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#B7BFC8",
    d: "M0 0h32v32H0z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "Campaigns_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h32v32H0z"
  })))));
};
export { SvgCampaigns as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMiAzMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzEyNDQ0XzU1ODY3NikiPgo8bWFzayBpZD0ibWFzazBfMTI0NDRfNTU4Njc2IiBzdHlsZT0ibWFzay10eXBlOmFscGhhIiBtYXNrVW5pdHM9InVzZXJTcGFjZU9uVXNlIiB4PSIyIiB5PSIxIiB3aWR0aD0iMzAiIGhlaWdodD0iMjkiPgo8cGF0aCBkPSJNMzAuNCAxMC4zMjA4VjcuNjc4NDRDMzAuNCA2LjI3ODA5IDI5Ljg0MzcgNC45MzUxMSAyOC44NTM1IDMuOTQ0OTFDMjcuODYzMyAyLjk1NDcyIDI2LjUyMDMgMi4zOTg0NCAyNS4xMiAyLjM5ODQ0SDkuMjhDNy44Nzk2NiAyLjM5ODQ0IDYuNTM2NjcgMi45NTQ3MiA1LjU0NjQ4IDMuOTQ0OTFDNC41NTYyOCA0LjkzNTExIDQgNi4yNzgwOSA0IDcuNjc4NDRWMTguMjM4NEM0IDE5LjYzODggNC41NTYyOCAyMC45ODE4IDUuNTQ2NDggMjEuOTcyQzYuNTM2NjcgMjIuOTYyMiA3Ljg3OTY2IDIzLjUxODQgOS4yOCAyMy41MTg0SDIyLjQ4IiBzdHJva2U9ImJsYWNrIiBzdHJva2Utd2lkdGg9IjIuNCIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik0xNy4yIDE4LjIzODNMMjIuNDggMjMuNTE4M0wxNy4yIDI4Ljc5ODMiIHN0cm9rZT0iYmxhY2siIHN0cm9rZS13aWR0aD0iMi40IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTI0LjA4MDEgMTguMjM4M0wyOS4zNjAxIDIzLjUxODNMMjQuMDgwMSAyOC43OTgzIiBzdHJva2U9ImJsYWNrIiBzdHJva2Utd2lkdGg9IjIuNCIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjwvbWFzaz4KPGcgbWFzaz0idXJsKCNtYXNrMF8xMjQ0NF81NTg2NzYpIj4KPHJlY3Qgd2lkdGg9IjMyIiBoZWlnaHQ9IjMyIiBmaWxsPSIjQjdCRkM4Ii8+CjwvZz4KPC9nPgo8ZGVmcz4KPGNsaXBQYXRoIGlkPSJjbGlwMF8xMjQ0NF81NTg2NzYiPgo8cmVjdCB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIGZpbGw9IndoaXRlIi8+CjwvY2xpcFBhdGg+CjwvZGVmcz4KPC9zdmc+Cg==";